import React , {useEffect} from 'react';
import './App.css';

import BuildInfo from './components/BuildInfo';
import {projectConfig} from '../../shared/project-info/projectConfig';
import Favicon from '../../shared/project-info/images/favicon.ico';
import Logo192 from '../../shared/project-info/images/logo192.png'
import Logo512 from '../../shared/project-info/images/logo512.png'
import AppleTouchIcon from '../../shared/project-info/images/apple-touch-icon.png'
import OGCover from '../../shared/project-info/images/opengraphcover.png';
import NavigationWrapper from './components/navigation/NavigationWrapper';
import { BrowserRouter as Router } from 'react-router-dom';
import { GOOGLE_MAP_API_KEY } from '../../shared/constants/APIKeys';

function App() {
  document.title=projectConfig.name;
  document.head.innerHTML += 
    "<link rel=\"icon\" sizes=\"16x16 32x32 64x64\" href="+ Favicon +" />" +
    "<meta name=\"description\" content="+ projectConfig.metaDescription +" />" +
    "<meta property=\"og:title\" content="+ projectConfig.name +" />" +
    "<meta property=\"og:type\" content=\"website\" />" +
    "<meta property=\"og:image\" content="+ OGCover +" />"+
    "<link rel=\"apple-touch-icon\" href="+ AppleTouchIcon +" />";
  var DynamicManifest = {
    "name": projectConfig.name,
    "short_name": projectConfig.slug,
    "description": projectConfig.metaDescription,
    "start_url": window.location.origin,
    "background_color": "#fff",
    "theme_color": projectConfig.primaryColorOne,
    "display": "standalone",
    "icons": [
      {
        "src": window.location.origin + Favicon,
        "sizes": "64x64 32x32 24x24 16x16",
        "type": "image/x-icon"
      },
      {
        "src": Logo192.match("data:") ? Logo192 : window.location.origin + Logo192,
        "type": "image/png",
        "sizes": "192x192"
      },
      {
        "src": Logo512.match("data:") == 'data:' ? Logo512 : window.location.origin + Logo512,
        "type": "image/png",
        "sizes": "512x512"
      }
    ],
  }
  const stringManifest = JSON.stringify(DynamicManifest);
  const blob = new Blob([stringManifest], {type: 'application/json'});
  const manifestURL = URL.createObjectURL(blob);
  document.querySelector('#webmanifest').setAttribute('href', manifestURL);
useEffect(()=>{
  const script = document.createElement('script');
  script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAP_API_KEY}&libraries=places`;
  document.body.appendChild(script)
},[])

  return (
    <div className="App">
      <Router>
      <BuildInfo />
      <NavigationWrapper />
      </Router>
    </div>
  );
}

export default App;
